export default __webpack_public_path__ + "static/media/BM_RenderCamera_14_Balcony+Interior+Light_Scheme.8ee403f9.jpg";